(function () {
  var drawer = document.getElementById('mqCartDrawer');
  if (!drawer) return;

  var overlay = drawer.querySelector('.mq-cart-drawer__overlay');
  var body = document.getElementById('mqCartBody');
  var subtotalEl = document.getElementById('mqCartSubtotal');
  var checkoutBtn = document.getElementById('mqCartCheckout');
  var countEls = document.querySelectorAll('[data-mq-cart-count]');

  function money(cents) {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
  }

  function setCount(n) {
    countEls.forEach(function (el) {
      el.textContent = String(n);
    });
  }

  function suppressThirdPartyCarts() {
    var sel =
      'kaching-cart-drawer, kaching-cart, [class*="kaching-cart-drawer"], cart-drawer, #CartDrawer';
    document.querySelectorAll(sel).forEach(function (el) {
      if (el.closest && el.closest('#mqCartDrawer')) return;
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function openDrawer() {
    suppressThirdPartyCarts();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCart();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function lineHtml(item) {
    var img = item.image
      ? '<img src="' + item.image + '" alt="" width="72" height="72" loading="lazy">'
      : '';
    return (
      '<div class="mq-cart-line" data-key="' +
      item.key +
      '">' +
      '<div class="mq-cart-line__img">' +
      img +
      '</div>' +
      '<div><div class="mq-cart-line__title">' +
      item.product_title +
      '</div>' +
      (item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="mq-cart-line__variant">' + item.variant_title + '</div>'
        : '') +
      '<div class="mq-cart-line__price">' +
      money(item.final_line_price) +
      '</div>' +
      '<div class="mq-cart-line__controls">' +
      '<div class="mq-cart-line__qty">' +
      '<button type="button" data-qty="-1" data-key="' +
      item.key +
      '" aria-label="Moins">−</button>' +
      '<span>' +
      item.quantity +
      '</span>' +
      '<button type="button" data-qty="1" data-key="' +
      item.key +
      '" aria-label="Plus">+</button>' +
      '</div>' +
      '<button type="button" class="mq-cart-line__remove" data-remove="' +
      item.key +
      '">Retirer</button>' +
      '</div>' +
      '</div></div>'
    );
  }

  function renderCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        setCount(cart.item_count);
        if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
        if (!body) return;
        if (!cart.items.length) {
          body.innerHTML =
            '<div class="mq-cart-drawer__empty"><p>Votre panier est vide</p><a class="btn btn--yellow" href="/collections/all">Continuer mes achats</a></div>';
          if (checkoutBtn) checkoutBtn.hidden = true;
          return;
        }
        if (checkoutBtn) checkoutBtn.hidden = false;
        body.innerHTML = cart.items.map(lineHtml).join('');
      })
      .catch(function () {});
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function () {
        renderCart();
      })
      .catch(function () {});
  }

  document.querySelectorAll('[data-mq-open-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  });

  drawer.querySelectorAll('[data-mq-close-cart]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  if (body) {
    body.addEventListener('click', function (e) {
      var t = e.target;
      if (t.matches('[data-qty]')) {
        var key = t.getAttribute('data-key');
        var delta = parseInt(t.getAttribute('data-qty'), 10);
        var row = t.closest('.mq-cart-line');
        var qtyEl = row && row.querySelector('.mq-cart-line__qty span');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) + delta : 1;
        changeLine(key, Math.max(0, qty));
      }
      if (t.matches('[data-remove]')) {
        changeLine(t.getAttribute('data-remove'), 0);
      }
    });
  }

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (window.mqLegereMetaOnInitiateCheckout) {
        try {
          window.mqLegereMetaOnInitiateCheckout();
        } catch (metaErr) {}
      }
      window.location.href = checkoutBtn.getAttribute('href') || '/checkout';
    });
  }

  var pageRoot = document.getElementById('mqCartPage');
  if (pageRoot) {
    pageRoot.addEventListener('click', function (e) {
      var t = e.target;
      if (t.matches('[data-qty]')) {
        var key = t.getAttribute('data-key');
        var delta = parseInt(t.getAttribute('data-qty'), 10);
        var row = t.closest('.mq-cart-page__line');
        var qtyEl = row && row.querySelector('[data-qty-value]');
        var qty = qtyEl ? parseInt(qtyEl.textContent, 10) + delta : 1;
        changeLine(key, Math.max(0, qty)).then(function () {
          window.location.reload();
        });
      }
      if (t.matches('[data-remove]')) {
        changeLine(t.getAttribute('data-remove'), 0).then(function () {
          window.location.reload();
        });
      }
    });
  }

  var burger = document.getElementById('mqProductBurger');
  var mnav = document.getElementById('mnav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    mnav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mnav.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  window.mqRefreshCart = renderCart;
  window.mqOpenCart = openDrawer;
  document.addEventListener('DOMContentLoaded', renderCart);
})();
